<template>
  <div id="results-page" class="page">
    <div v-if="isLoading" class="loader">
      <div class="justify-content-center jimu-primary-loading"></div>
    </div>
    <div v-if="showFiltersPopup" class="overlay" @click="showFiltersPopup = false">
      <div class="filters-modal" @click.stop>
        <div class="filters-modal-header">
          <h3>Cab Filters</h3>
          <button class="close-btn" @click="showFiltersPopup = false">✕</button>
        </div>
        <div class="filters-content">
          <div class="filter-header">
            <h3>Filters</h3>
            <button class="clear-filters-btn" @click="clearAllFilters">
              Clear All
            </button>
          </div>

          <!-- Filters Sections -->
          <div class="filter-sections">
            <div class="filter-section">
              <h4 style="text-align: left">Car Type</h4>
              <div class="filter-options">
                <button class="filter-chip" :class="{ active: filters.carType.includes('hatchback') }"
                  @click="toggleFilter('carType', 'hatchback')">
                  Hatchback
                </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('sedan') }"
                  @click="toggleFilter('carType', 'sedan')">
                  Sedan
                </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('suv') }"
                  @click="toggleFilter('carType', 'suv')">
                  SUV
                </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('suv+') }"
                  @click="toggleFilter('carType', 'suv+')">
                  SUV+
                </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('innova') }"
                  @click="toggleFilter('carType', 'innova')">
                  Toyota Innova
                </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('crysta') }"
                  @click="toggleFilter('carType', 'crysta')">
                  Crysta
                </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('premium') }"
                  @click="toggleFilter('carType', 'premium')">
                  Premium
                </button>
              </div>
            </div>
            <div class="filter-section">
              <h4 style="text-align: left">Fuel Type</h4>
              <label>
                <input type="checkbox" value="Petrol" v-model="filters.fuelType" />
                Petrol
              </label>
              <label>
                <input type="checkbox" value="Diesel" v-model="filters.fuelType" />
                Diesel
              </label>
              <label>
                <input type="checkbox" value="CNG" v-model="filters.fuelType" />
                CNG
              </label>
              <label>
                <input type="checkbox" value="Electric" v-model="filters.fuelType" />
                Electric
              </label>
            </div>

            <div class="filter-section">
              <h4 style="text-align: left">Price Range</h4>
              <div class="price-range">
                <input type="range" v-model="priceMin" min="500" max="15000" @input="updatePriceFilter" />
                <input type="range" v-model="priceMax" min="500" max="15000" @input="updatePriceFilter" />
                <div class="price-labels">
                  <span>₹{{ priceMin }}</span>
                  <span>₹{{ priceMax }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="results-container">
      <!-- Sidebar Filters (Desktop) -->
      <div class="filters-sidebar" v-show="filtersVisible">
        <div class="filter-header">
          <h3>Filters</h3>
          <button class="clear-filters-btn" @click="clearAllFilters">
            Clear All
          </button>
        </div>

        <div class="filter-sections">
          <div class="filter-section">
            <h4 style="text-align: left">Car Type</h4>
            <div class="filter-options">
              <button class="filter-chip" :class="{ active: filters.carType.includes('hatchback') }"
                @click="toggleFilter('carType', 'hatchback')">
                Hatchback
              </button>
              <button class="filter-chip" :class="{ active: filters.carType.includes('sedan') }"
                @click="toggleFilter('carType', 'sedan')">
                Sedan
              </button>
              <button class="filter-chip" :class="{ active: filters.carType.includes('suv') }"
                @click="toggleFilter('carType', 'suv')">
                SUV
              </button>
              <button class="filter-chip" :class="{ active: filters.carType.includes('suv+') }"
                @click="toggleFilter('carType', 'suv+')">
                SUV+
              </button>
              <button class="filter-chip" :class="{ active: filters.carType.includes('innova') }"
                @click="toggleFilter('carType', 'innova')">
                Toyota Innova
              </button>
              <button class="filter-chip" :class="{ active: filters.carType.includes('crysta') }"
                @click="toggleFilter('carType', 'crysta')">
                Crysta
              </button>
                <button class="filter-chip" :class="{ active: filters.carType.includes('premium') }"
                  @click="toggleFilter('carType', 'premium')">
                  Premium
                </button>
            </div>
          </div>
          <hr />
          <div class="filter-section">
            <h4 style="text-align: left">Fuel Type</h4>
            <div class="filter-options">
              <button class="filter-chip" :class="{ active: filters.fuelType.includes('cng') }"
                @click="toggleFuelType('cng')">
                CNG
              </button>
              <button class="filter-chip" :class="{ active: filters.fuelType.includes('petrol') }"
                @click="toggleFuelType('petrol')">
                Petrol
              </button>
              <button class="filter-chip" :class="{ active: filters.fuelType.includes('diesel') }"
                @click="toggleFuelType('diesel')">
                Diesel
              </button>
              <button class="filter-chip" :class="{ active: filters.fuelType.includes('electric') }"
                @click="toggleFuelType('electric')">
                Electric
              </button>
            </div>
          </div>
          <hr />
        </div>
      </div>

      <!-- Main Results -->
      <div class="results-main text-start" style="margin-top: 64px;">
        <div class="results-header">
          <div class="results-info">
            <h2>
              <span> {{ displaySourceAddress }}</span> <v-icon v-if="routerData.tripType != 2"
                color="#00000045">mdi-arrow-right</v-icon> <v-icon v-else size="small"
                color="#00000045">mdi-arrow-left-right</v-icon> <span>{{ displayDestinationAddress
                }}</span>
            </h2>
            <p class="text-left">
              {{ displayStartDate }} • {{ displayStartTime }} •
              {{ cabs.length }} cabs available
            </p>
          </div>
          <div class="results-controls desktop-only">
            <select v-model="sortOption" @change="updateSort">
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
              <option value="rating-desc">Rating: High to Low</option>
            </select>
          </div>
        </div>
        <br />

        <div class="cab-results">
          <div v-if="filteredCabs.length === 0" class="no-cabs-found">
            <div class="no-cabs-content">
              <img src="@/assets/transport.png" alt="No cabs found" class="no-cabs-logo" width="120" />
              <h3>No Cabs Found</h3>
              <p>Sorry, we couldn't find any cabs matching your selected filters.</p>
            </div>
          </div>
          <div v-else v-for="(cab, index) in filteredCabs" :key="index" class="cab-card"
            :class="{ recommended: cab.recommended }">
            <!-- Left Section -->
            <div class="cab-left">
              <div class="cab-image">
                <img :src="cab.cab?.image ? cab.cab.image : require('@/assets/transport.png')" alt="Cab"
                  class="cab-img" />

                <div class="fuel-strip" :class="'fuel-' + cab.cab.fuelType.toLowerCase().replace('/', '-')">
                  {{ cab.cab.fuelType != 'Unknown' ? cab.cab.fuelType : "CNG/Petrol" }}
                </div>
              </div>
              <div class="cab-details">
                <h3>
                  {{ cab.cab.model ?? cab.cab.cabType }}
                  <span class="badge">{{ cab.cab.cabType }}</span>
                </h3>
                <p style="text-align: left" class="d-flex align-center">
                  <img :src="mediaUrl + cab.aggregator_logo" width="60"
                    :height="cab.aggregator_name == 'meru' ? '50' : (cab.aggregator_name == 'Namma Yatri' ? '30' : '30')"
                    alt="">
                  ⭐ {{ cab.AndroidRating || 4.8 }}
                </p>
                <v-spacer></v-spacer>
                <p style="text-align: left">
                  {{ cab.cab.seatingCapacity ?? 4 }} Seats •
                  AC
                  <span class="pa-1 text-body-2 rounded ml-3" style="background: #eff6ff;color: #155dfc;">
                    <v-icon size="14">mdi-clock-outline</v-icon>
                    {{ formatTime(cab.pickUpTime) }}
                  </span>
                </p>
              </div>
            </div>

            <!-- Right Section -->
            <div class="cab-price">
              <div class="price-info">
                <span class="discount-badge" v-if="cab.fare.discountAmount < cab.fare?.totalAmount">
                  {{
                    calculateDiscount(
                      cab.fare?.totalAmount,
                      cab.fare.discountAmount
                    )
                  }}% OFF
                </span>
                <span class="original-price" v-if="cab.fare.discountAmount < cab.fare.totalAmount">
                  ₹{{ cab.fare?.totalAmount }}
                </span>
                <span class="final-price">₹{{ cab.fare.discountAmount }}</span>
              </div>
              <div class="tax-and-button-container">

                <div class="price-button-container">
                  <button class="instant-booking" @click="confirmBooking(cab)">
                    Select Cab
                  </button>
                </div>
              </div>
            </div>

            <div v-if="cab.recommended" class="recommend-tag">RECOMMENDED</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Buttons for Mobile -->
    <div class="bottom-buttons" v-if="!isLoading">
      <button @click="showFiltersPopup = true">All Filters</button>
      <button @click="showSortPopup = true">Sort</button>
    </div>

    <!-- Sort Popup -->
    <div v-if="showSortPopup" class="sort-modal-overlay" @click="showSortPopup = false">
      <div class="sort-modal" @click.stop>
        <div class="sort-header">
          <h3>Sort by</h3>
          <button class="clear-all" @click="sortOption = ''">CLEAR ALL</button>
        </div>
        <div class="sort-options">
          <button class="sort-chip" :class="{ active: sortOption === 'price-asc' }" @click="sortOption = 'price-asc'">
            Price: Lowest to Highest
          </button>
          <button class="sort-chip" :class="{ active: sortOption === 'price-desc' }" @click="sortOption = 'price-desc'">
            Price: Highest to Lowest
          </button>
          <button class="sort-chip" :class="{ active: sortOption === 'rating-desc' }"
            @click="sortOption = 'rating-desc'">
            Rating: Highest to Lowest
          </button>
        </div>
        <button class="apply-btn" @click="applySort">Apply</button>
      </div>
    </div>

    <v-dialog v-model="confirmDialog" max-width="520px" transition="dialog-bottom-transition">
      <v-card class="pa-5 rounded-xl" elevation="10">
        <div class="d-flex align-center mb-3">
          <v-avatar color="amber-lighten-4" size="48" class="mr-3">
            <v-icon color="orange-darken-2" size="28">mdi-alert-circle-outline</v-icon>
          </v-avatar>
          <div>
            <h3 class="text-h6 font-weight-bold mb-1">Confirm Ride</h3>
            <div class="text-body-2 text-grey-darken-1">
              By confirming your ride, ChooseApp will start looking for a driver.
            </div>
          </div>
        </div>

        <v-divider class="my-3"></v-divider>

        <v-list density="comfortable" class="rounded-lg">
          <v-list-item style="background: #fafafa;" class="border-sm rounded-lg pa-4">
            <v-list-item-title class="text-grey-darken-1 text-body-2"><v-list-item-icon class="mr-2"><v-icon
                  color="blue-darken-1">mdi-car-clock</v-icon></v-list-item-icon>
              The ride will be booked immediately once a driver is found.</v-list-item-title>
          </v-list-item>

          <v-list-item style="background: #fafafa;" class="border-sm rounded-lg pa-4 mt-3">

            <v-list-item-title class="text-grey-darken-1 text-body-2"> <v-list-item-icon class="mr-2"><v-icon
                  color="green-darken-1">mdi-cash</v-icon></v-list-item-icon>You may need to pay the driver
              directly.</v-list-item-title>
          </v-list-item>

          <v-list-item style="background: #fafafa;" class="border-sm rounded-lg pa-4 mt-3">

            <v-list-item-title class="text-grey-darken-1 text-body-2"><v-list-item-icon class="mr-2"><v-icon
                  color="deep-purple-darken-1">mdi-map-marker</v-icon></v-list-item-icon>Please be ready at the pickup
              location.</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider class="my-4"></v-divider>

        <v-card-actions class="justify-end">
          <v-btn variant="text" color="grey-darken-1" @click="confirmDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" class="px-6 rounded-lg" variant="tonal" @click="confirmRide">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="searchingDialog" max-width="460px" persistent>
      <v-card class="pa-5 text-center rounded-xl" elevation="10">
        <!-- Searching Text -->
        <div v-if="!searchCompleted && !driverFound">
          <!-- Loader / Lottie -->
          <div class="mb-4">
            <img src="@/assets/loader.gif" height="120" width="120" alt="Loading..." />
          </div>
          <div class="text-subtitle-1 font-weight-bold mb-2">Searching for a driver<span class="dots"></span></div>
          <div class="text-body-2 mb-3">
            Time remaining: <span class="text-blue font-weight-medium">{{ formattedTime }}</span>
          </div>

          <v-progress-linear color="blue-darken-2" height="6" rounded indeterminate class="mb-2"></v-progress-linear>

          <div class="text-body-2 text-grey-darken-1 mb-5">
            We're looking for the best driver for you
          </div>

          <v-btn color="grey-darken-1" style="text-transform:none" :loading="cancelLoading" block variant="outlined"
            @click="closeSearchDialog">
            Cancel Search
          </v-btn>
        </div>

        <!-- ✅ Driver Found -->
        <transition name="fade">
          <div v-if="driverFound" class="mt-3 text-center">
            <!-- ✅ Green Circle with Check Icon -->
            <div class="d-flex align-center justify-center mx-auto mb-4"
              style="height: 90px; width: 90px; border-radius: 50%; background-color: #e8f9ee;">
              <v-icon size="50" color="green">mdi-check-circle-outline</v-icon>
            </div>

            <!-- Title -->
            <h3 class="text-h6 font-weight-bold mb-1">Driver Found!</h3>
            <p class="text-body-2 text-grey-darken-1 mb-5">
              Your ride has been confirmed successfully.
            </p>

            <!-- Driver Details Card -->
            <v-sheet class="pa-4 rounded-lg mb-5 text-start" elevation="0" color="#fafafa" border>
              <!-- Driver Name -->
              <div class="d-flex align-center mb-3">
                <v-avatar color="green-lighten-5" size="40" class="me-3">
                  <v-icon color="green">mdi-account-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-body-2 text-grey-darken-1">Driver Name</div>
                  <div class="text-subtitle-2 font-weight-medium">Rajesh Kumar</div>
                </div>
              </div>

              <v-divider></v-divider>

              <!-- Vehicle Number -->
              <div class="d-flex align-center my-3">
                <v-avatar color="blue-lighten-5" size="40" class="me-3">
                  <v-icon color="blue">mdi-car-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-body-2 text-grey-darken-1">Vehicle Number</div>
                  <div class="text-subtitle-2 font-weight-medium">DL 3C AB 1234</div>
                </div>
              </div>

              <v-divider></v-divider>

              <!-- Phone Number -->
              <div class="d-flex align-center mt-3">
                <v-avatar color="purple-lighten-5" size="40" class="me-3">
                  <v-icon color="purple">mdi-phone-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-body-2 text-grey-darken-1">Phone Number</div>
                  <div class="text-subtitle-2 font-weight-medium">+91 98765 43210</div>
                </div>
              </div>
            </v-sheet>

            <!-- OTP Section -->
            <v-sheet class="pa-4 rounded-lg mb-6" color="#fff8ef" border style="border-color: #ffb84d;">
              <div class="d-flex align-center justify-center mb-3">
                <v-icon color="orange" class="me-2">mdi-key-outline</v-icon>
                <span class="text-subtitle-2 font-weight-medium text-orange-darken-2">
                  Your Ride OTP
                </span>
              </div>

              <!-- OTP Boxes -->
              <div class="d-flex justify-center mb-2">
                <div v-for="n in [5, 8, 2, 7]" :key="n"
                  class="mx-1 text-h6 font-weight-bold d-flex align-center justify-center"
                  style="height: 50px; width: 45px; border: 2px solid #ffb84d; border-radius: 8px;">
                  {{ n }}
                </div>
              </div>

              <div class="text-caption text-orange-darken-2">
                Share this OTP with your driver
              </div>
            </v-sheet>

            <!-- Buttons -->
            <v-btn color="green" block class="mb-3" height="45" rounded style="text-transform:none"
              @click="$router.push('/AppTrip')">
              View Ride Details
            </v-btn>

            <v-btn variant="outlined" color="grey-darken-1" block height="45" rounded style="text-transform:none"
              @click="closeSearchDialog">
              Close
            </v-btn>
          </div>
        </transition>

        <!-- ❌ No Driver Found -->
        <transition name="fade">
          <div v-if="searchCompleted && !driverFound">
            <!-- Red Icon in Circle -->
            <div class="d-flex align-center justify-center mx-auto mb-4"
              style="height: 90px; width: 90px; border-radius: 50%; background-color: #ffe6e6;">
              <v-icon size="50" color="red">mdi-close-circle-outline</v-icon>
            </div>

            <!-- Heading -->
            <h3 class="text-h6 font-weight-bold mb-2">No Drivers Found</h3>

            <!-- Description -->
            <p class="text-body-2 text-grey-darken-1 mb-4">
              We couldn't find a driver within 2 minutes. Please try again later.
            </p>

            <!-- Info Box -->
            <v-sheet color="#f7f9ff" class="pa-3 rounded-lg mb-5 d-flex align-start" elevation="0">
              <v-icon color="amber" class="me-2 mt-1">mdi-lightbulb-on-outline</v-icon>
              <span class="text-body-2 text-grey-darken-2 text-start">
                Peak hours may have limited drivers. Try increasing your fare or waiting a few minutes.
              </span>
            </v-sheet>

            <!-- Buttons -->
            <v-btn color="orange-darken-2" class="mb-3" block height="45" style="text-transform:none"
              @click="confirmRide">
              <v-icon left>mdi-refresh</v-icon>
              Try Again
            </v-btn>

            <v-btn variant="outlined" color="grey-darken-1" block height="45" style="text-transform:none"
              @click="closeSearchDialog">
              Close
            </v-btn>
          </div>
        </transition>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import axios from "axios";
import {
  parseUrlPayload,
  isPlausibleSearchPayload,
  safeText,
  safeDate,
  safeTime,
} from "@/utils/urlPayload";

export default {
  data() {
    return {
      isLoading: true, // Added loader state
      confirmDialog: false,
      searchingDialog: false,
      searchInProgress: false,
      selectedCab: null,
      priceMin: 100,
      priceMax: 100000,
      sortOption: "price-asc",
      showFiltersPopup: false,
      cancelLoading: false,
      showSortPopup: false,
      searchCompleted: false,
      driverFound: false,
      timer: 120,
      intervalId: null,
      filters: {
        carType: [],
        provider: [],
        fuelType: [],
      },
      data: [],
      routerData: {},
      filtersVisible: true,
      showMenuButton: false,
      pickUpDate: "2025-09-22",
      sourceCityName: "Navi Mumbai",
      destinationCityName: "Mumbai",
      pickUpTime: "20:45:00",
      aggregator_id: 1,
      aggregator_name: "gozo",
      aggregator_logo: "choosecab/aggregators/logo/1/photo_66d0693a57802.png",
      IosRating: "3.1",
      AndroidRating: "4.0",
      cabs: [
      ],
    };
  },
  computed: {
    // Everything the template shows from `routerData` goes through these, so a
    // payload that passed the structural check still cannot put arbitrary text
    // in the results header. Blank is an acceptable render; attacker copy is not.
    displaySourceAddress() {
      return safeText(this.routerData.sourceAddress, 25);
    },
    displayDestinationAddress() {
      return safeText(this.routerData.destinationAddress, 25);
    },
    displayStartDate() {
      return safeDate(this.routerData.startDate);
    },
    displayStartTime() {
      return safeTime(this.routerData.startTime);
    },
    formattedTime() {
      const minutes = Math.floor(this.timer / 60)
      const seconds = this.timer % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`
    },
    filteredCabs() {
      let result = [...this.cabs];

      // Price filter
      result = result.filter(
        (cab) =>
          cab.fare.totalAmount >= this.priceMin &&
          cab.fare.totalAmount <= this.priceMax
      );

      result = result.filter(cab => {
        const type = cab?.cab?.cabType?.toLowerCase() || "";
        return !type.includes("tempo") && !type.includes("van");
      });


      if (this.filters.fuelType.length > 0) {
        result = result.filter((cab) => {
          return this.filters.fuelType.some((fuel) =>
            cab.cab.fuelType.toLowerCase().includes(fuel)
          );
        });
      }

      // Car type filter
      if (this.filters.carType.length > 0) {
        result = result.filter((cab) =>
          this.filters.carType.includes(cab?.cab?.cabType?.toLowerCase())
        );
      }

      // Sorting
      if (this.sortOption === "price-asc") {
        result.sort((a, b) => a.fare.totalAmount - b.fare.totalAmount);
      } else if (this.sortOption === "price-desc") {
        result.sort((a, b) => b.fare.totalAmount - a.fare.totalAmount);
      } else if (this.sortOption === "rating-desc") {
        result.sort((a, b) => {
          const ratingA =
            a.rating ||
            (parseFloat(a.IosRating) + parseFloat(a.AndroidRating)) / 2;
          const ratingB =
            b.rating ||
            (parseFloat(b.IosRating) + parseFloat(b.AndroidRating)) / 2;
          return ratingB - ratingA;
        });
      }
      return result;
    },
  },
  mounted() {

    window.addEventListener("beforeunload", this.handleBeforeUnload, { capture: true });
    window.addEventListener('pagehide', this.handleBeforeUnload, { capture: true });
    window.addEventListener('unload', this.handleBeforeUnload, { capture: true });
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    // The `?data=` payload is caller-supplied, so it is validated before it is
    // stored or rendered. A payload our search widget would not have produced
    // (fuzzed escapes, impossible dates, out-of-range coordinates) sends the
    // visitor to the homepage instead of rendering attacker-chosen content on
    // one of our pages. See src/utils/urlPayload.js.
    const payload = parseUrlPayload(this.$route.query.data);
    if (!isPlausibleSearchPayload(payload)) {
      this.$router.replace({ name: "Home" });
      return;
    }
    this.routerData = payload;
    this.fetchCabs();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener("beforeunload", this.handleBeforeUnload, { capture: true });
    window.removeEventListener('pagehide', this._pagehideHandler, { capture: true });


    window.removeEventListener('unload', this.handleBeforeUnload, { capture: true });

    clearInterval(this.intervalId)

  },
  methods: {
    truncate(text, length = 25) {
      if (!text) return '';
      return text.length > length ? text.slice(0, length) + '...' : text;
    },
    async abortSearch() {
      if (!this.searchInProgress && this.selectedCab.transaction_id == null) return;

      try {
        await axios.post("/abort-request", { transactionId: this.selectedCab.transaction_id, aggregator_name: this.selectedCab.aggregator_name });
      } catch (err) {
        console.error("Abort failed:", err);
      } finally {
        this.searchInProgress = false;
        this.searchingDialog = false;
      }
    },
    async fetchCabs() {
      // routerData was already validated in mounted(). Re-reading the URL here
      // would reintroduce the unchecked path, and threw outright when `data` was
      // absent (`payload.referenceId` on null).
      const payload = { ...this.routerData };
      payload.referenceId = "ref_" + Math.random().toString(36).substr(2, 9);
      this.routerData.referenceId = payload.referenceId;
      if (payload.tripType != 3) {
        let distance = await this.calculateDistance(this.routerData);
        payload.destination = distance / 1000
      }
      if (payload.tripType == 4 && new Date(parseInt(payload.startTime)).getTime() <= Date.now()) {
        payload.isBookNow = true
      }
      try {
        let response = await axios.post(
          "/new_check_availabilities",
          payload
        );
        this.data = response.data.data
        response.data.data.forEach(Parentelement => {
          Parentelement.cabRate.forEach(element => {
            this.cabs.push({
              cab: element.cab,
              IosRating: Parentelement.IosRating,
              AndroidRating: Parentelement.AndroidRating,
              fare: element.fare,
              aggregator_name: Parentelement.aggregator_name,
              pickUpTime: Parentelement.pickUpTime,
              pickUpDate: Parentelement.pickUpDate,
              aggregator_logo: Parentelement.aggregator_logo,
              transaction_id: Parentelement.transaction_id,
              aggregator_id: Parentelement.aggregator_id
            })
          })
        });
        this.isLoading = false;
      } catch (err) {
        console.error("API Error:", err);
        this.isLoading = false;
      }

    },
    confirmRide() {
      this.searchCompleted = false
      this.confirmBooking(this.selectedCab)
      this.confirmDialog = false
      this.startSearching()
    },
    startSearching() {
      this.searchingDialog = true
      this.searchInProgress = true;
      this.timer = 120
      this.intervalId = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this.intervalId)
          this.searchCompleted = true
          this.searchInProgress = false;
        }
      }, 1000)
    },
    formatTime(time) {
      if (!time) return ""

      const [hoursStr, minutesStr] = time.split(":")
      let hours = parseInt(hoursStr, 10)
      const ampm = hours >= 12 ? "PM" : "AM"

      // Convert 24h → 12h format
      hours = hours % 12
      hours = hours ? hours : 12

      return `${hours}:${minutesStr} ${ampm}`
    },
    async closeSearchDialog() {
      this.cancelLoading = true;
      if (this.searchInProgress) {
        await this.abortSearch()
        this.cancelLoading = false;
        this.$router.push('/');
      }
    },
    async calculateDistance(data) {
      try {
        const response = await fetch(`https://api.olamaps.io/routing/v1/distanceMatrix?origins=${data.sourceLat}%2C${data.sourceLong}&destinations=${data.destinationLat}%2C${data.destinationLong}&api_key=4Iqe4NDsH1uxOnmUNHtBluas3wdf4lcIrsRvE36q&components=country:IN`);
        const json = await response.json();
        return json.rows[0].elements[0].distance
      } catch (error) {
        console.error("Error calculating distance:", error);
      }

    },
    toggleFilter(type, value) {
      console.log('type', type, 'value', value, 'filters', this.filters.carType)
      const index = this.filters[type].indexOf(value);
      if (index === -1) {
        this.filters[type].push(value);
      } else {
        this.filters[type].splice(index, 1);
      }
    },
    openFiltersPopup() {
      this.showFiltersPopup = true;
    },
    updatePriceFilter() {
      if (this.priceMin > this.priceMax) {
        [this.priceMin, this.priceMax] = [this.priceMax, this.priceMin];
      }
    },
    clearAllFilters() {
      this.filters.carType = [];
      this.filters.provider = [];
      this.priceMin = 500;
      this.priceMax = 15000;
    },
    togglePriceComparison() {
      alert("Compare Prices feature coming soon!");
    },
    toggleFilters() {
      this.filtersVisible = !this.filtersVisible;
    },
    checkScreenSize() {
      this.showMenuButton = window.innerWidth <= 768;
      this.filtersVisible = window.innerWidth > 768;
    },
    async confirmBooking(cab) {
      // Check if user is logged in
      const isLoggedIn = localStorage.getItem('token');
      if (!isLoggedIn) {
        // Emit an event to show the login popup
        this.$emit('show-login-popup', { cab: cab, routerData: this.routerData });
        return;
      }

      if (cab.transaction_id != null && this.searchingDialog == false && this.confirmDialog == false) {
        this.selectedCab = cab
        this.confirmDialog = true
        return
      }

      this.isLoading = true;
      // Get the logged in user ID
      const userId = this.$store.getters['auth/user'].id || 52;

      const formData = {
        tnc: 1,
        referenceId: this.routerData.referenceId,
        transactionId: cab.transaction_id,
        tripType: this.routerData.tripType,
        cabType: cab.cab?.id?.toString(),
        advanceReceived: "0",
        totalAmount: cab.fare.totalAmount,
        sendEmail: 1,
        sendSms: 1,
        startDate: cab.pickUpDate,
        startTime: cab.pickUpTime,
        sourceAddress: this.routerData.sourceAddress,
        sourceName: this.routerData.sourceAddress,
        sourceLat: this.routerData.sourceLat,
        sourceLong: this.routerData.sourceLong,
        destinationAddress: this.routerData.destinationAddress,
        destinationName: this.routerData.destinationAddress,
        destinationLat: this.routerData.destinationLat,
        destinationLong: this.routerData.destinationLong,
        image: cab.cab.image ?? '../assets/transport.png',
        firstName: "Test",
        lastName: "user",
        primaryContactCode: 91,
        primaryContactNumber: 9326988000,
        email: "abc@gmail.com",
        aggregator_id: cab.aggregator_id.toString(),
        aggregator_name: cab.aggregator_name,
        rating: cab.AndroidRating,
        company_id: 1,
        user_id: userId, // Use the logged in user ID
        vehicle_type: cab.cab.cabType,
      };

      if (cab.transaction_id != null) {
        this.ondcLoader = true
        await axios.post('http://chooseverify.aaibuzz.com/book-now', formData).then(response => {
          console.log('response', response)
          this.driverFound = true
          this.ondcLoader = false
        }).catch(error => {
          console.error(error);
          this.ondcLoader = false
        });
        return;
      }

      const queryString = encodeURIComponent(JSON.stringify(formData))

      this.$router.push({
        name: "ConfirmBooking",
        query: {
          data: queryString
        },
      });
    },

    calculateDiscount(original, discounted) {
      if (!original || !discounted) return 0;
      return Math.round(((original - discounted) / original) * 100);
    },
    calculateTaxes(fare) {
      return (
        (fare.gst || 0) +
        (fare.tollTax || 0) +
        (fare.stateTax || 0) +
        (fare.ParkingCharges || 0)
      );
    },
    toggleFuelType(fuel) {
      if (this.filters.fuelType.includes(fuel)) {
        this.filters.fuelType = this.filters.fuelType.filter((f) => f !== fuel);
      } else {
        this.filters.fuelType.push(fuel);
      }
    },
    applySort() {
      this.showSortPopup = false;
    },
    handleBeforeUnload() {
      try {
        if (!this.searchInProgress) {
          return;
        }
        const payload = {
          transactionId: this.selectedCab?.transaction_id || ('fallback_' + Date.now()),
          aggregator_name: this.selectedCab?.aggregator_name || this.aggregator_name || 'unknown'
        }


        const data = new FormData();
        data.append('transactionId', payload.transactionId);
        data.append('aggregator_name', payload.aggregator_name);



        // 1) Real backend (full absolute URL) - keep this for actual abort
        try {
          navigator.sendBeacon('https://backend.choosecabs.com/api/abort-request', data);
          // no await — beacon is fire & forget
        } catch (e) {
          console.warn('backend sendBeacon failed', e);
          // fallback: try fetch keepalive
        }

      } catch (err) {
        console.error('handleBeforeUnload failed:', err);
      }
    }

  },
};
</script>

<style scoped>
.dots::after {
  content: '';
  display: inline-block;
  width: 0.8em;
  text-align: left;
  animation: dots 1s steps(3, end) infinite;
}

@keyframes dots {

  0%,
  20% {
    content: '';
  }

  40% {
    content: '.';
  }

  60% {
    content: '..';
  }
}
</style>

<style>
/* Loader */
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.jimu-primary-loading {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>

<style scoped>
/* Layout */
#results-page {
  display: flex;
}

.results-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.filters-sidebar {
  width: 25%;
  padding: 20px;
  margin-top: 64px;
  border-right: 1px solid #ddd;
  background: #fff;
  border-radius: 8px;
  transition: transform 0.3s ease;
  position: sticky;
  top: 64px;
  height: calc(100vh - 64px);
  overflow-y: auto;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.filters-sidebar::-webkit-scrollbar {
  width: 0;
}

/* Hide scrollbar for IE, Edge and Firefox */
.filters-sidebar {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.results-main {
  width: 75%;
  padding: 20px;
  background: #fff;
  overflow-y: auto;
  border-radius: 8px;
  max-height: calc(100vh - 64px);
  overflow-x: hidden;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.results-main::-webkit-scrollbar {
  width: 0;
}

/* Hide scrollbar for IE, Edge and Firefox */
.results-main {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.filters-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 80%;
  max-width: 320px;
  height: 100%;
  background: #fff;
  z-index: 1001;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.filters-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ddd;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.filters-content {
  padding: 16px;
  overflow-y: auto;
}

/* Menu Button */
.menu-btn {
  display: none;
  position: fixed;
  top: 10px;
  left: 10px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px;
  font-size: 24px;
  cursor: pointer;
  z-index: 1000;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.button-group button {
  padding: 6px 14px;
  border: 1px solid #ccc;
  background: #f8f9fa;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.button-group button.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}

/* Filters */
.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.compare-btn {
  width: 100%;
  border: 1px solid #ddd;
  padding: 10px;
  margin: 15px 0;
  cursor: pointer;
  background: #fff;
  border-radius: 6px;
}

.price-range input {
  width: 100%;
  margin: 5px 0;
}

.price-labels {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.filter-chip {
  background: #f7f7f7;
  border: 1px solid #ddd;
  padding: 6px 12px;
  margin: 4px;
  border-radius: 6px;
  cursor: pointer;
}

.filter-chip.active {
  background: #e5f0ff;
  color: #007bff;
  border-color: #007bff;
}

/* Results Header */
.results-header {
  position: static;
  background: #fff;
  z-index: 100;
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.results-info {
  flex: 1;
  min-width: 200px;
}

.results-controls {
  min-width: 150px;
}

.desktop-only {
  display: block;
}

.results-header h2 {
  margin: 0 0 5px 0;
  font-size: 20px;
  line-height: 1.3;
}

.results-header p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.results-controls select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 100%;
  background-color: white;
  font-size: 14px;
}

@media (max-width: 480px) {
  .results-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .results-controls {
    width: 100%;
  }

  .results-header h2 {
    font-size: 16px;
  }

  .results-header p {
    font-size: 12px;
  }
}

/* Cab Cards */
.cab-card {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  margin-bottom: 15px;
  position: relative;
  transition: box-shadow 0.2s ease;
}

.cab-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cab-left {
  display: flex;
  align-items: center;
  min-width: 0;
  /* Allows flex items to shrink below their content size */
  flex: 1;
}

.cab-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-right: 15px;
  overflow: hidden;
  flex-shrink: 0;
}

.cab-img {
  width: 100%;
  height: 71%;
  object-fit: contain;
}

.fuel-strip {
  width: 100%;
  text-align: center;
  font-size: 11px;
  font-weight: bold;
  color: white;
  padding: 2px 0;
}

.fuel-cng {
  background-color: #009688;
}

.fuel-cng-diesel {
  background-color: #009688;
}

.fuel-unknown {
  background-color: #009688;
}

.fuel-diesel {
  background-color: #009688;
}

.fuel-petrol {
  background-color: #007bff;
}

.fuel-diesel-petrol {
  background-color: #007bff;
}

.fuel-electric {
  background-color: #4caf50;
}

.cab-details {
  flex: 1;
  min-width: 0;
  /* Allows this to shrink if needed */
}

.cab-details h3 {
  margin: 0 0 5px 0;
  font-size: 16px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.cab-details .badge {
  background: #e5f0ff;
  color: #007bff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 6px;
  margin-left: 6px;
  flex-shrink: 0;
}

.cab-details p {
  margin: 3px 0;
  font-size: 13px;
}

.cab-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  min-width: 120px;
  text-align: right;
}

.tax-and-button-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  margin-top: 8px;
}

.price-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 8px;
}

.discount-badge {
  background-color: #e8f5e9;
  color: #2e7d32;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  margin-bottom: 4px;
  align-self: flex-end;
}

.original-price {
  text-decoration: line-through;
  color: #888;
  font-size: 13px;
  margin-bottom: 2px;
}

.final-price {
  font-size: 20px;
  font-weight: bold;
  color: #d32f2f;
}

.tax-info {
  font-size: 11px;
  color: #666;
  margin: 0 0 8px 0;
  text-align: right;
}

.price-button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.instant-booking {
  background-color: #007bff;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  max-width: 120px;
  font-size: 14px;
  min-width: 100px;
}

.instant-booking:hover {
  background-color: #0056b3;
}

.recommend-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: #007bff;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 0 6px 0 6px;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .filters-sidebar {
    width: 30%;
    padding: 18px;
  }

  .results-main {
    width: 70%;
    padding: 18px;
  }

  .results-header h2 {
    font-size: 18px;
  }
}

@media (max-width: 1024px) {
  .filters-sidebar {
    width: 35%;
    padding: 15px;
  }

  .results-main {
    width: 65%;
    padding: 15px;
  }

  .cab-card {
    padding: 12px;
  }

  .cab-details h3 {
    font-size: 15px;
  }

  .final-price {
    font-size: 18px;
  }
}

@media (max-width: 768px) {
  #results-page {
    flex-direction: column;
  }

  .results-container {
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  }

  .filters-sidebar {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 999;
    transform: translateX(-100%);
    border-right: none;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    padding: 12px;
    position: fixed;
    /* Override the sticky positioning for mobile */
    top: 0;
    height: 100vh;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .filters-sidebar::-webkit-scrollbar {
    width: 0;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .filters-sidebar {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }

  .filters-sidebar.filters-hidden {
    transform: translateX(-100%);
  }

  .filters-sidebar:not(.filters-hidden) {
    transform: translateX(0);
  }

  .results-main {
    width: 100%;
    padding: 12px;
    max-height: unset;
    margin-top: 0;
  }

  .menu-btn {
    display: block;
  }

  .results-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .results-info {
    width: 100%;
    margin-bottom: 10px;
  }

  .results-controls select {
    width: 100%;
    font-size: 14px;
    padding: 8px;
  }

  .cab-card {
    flex-direction: row;
    flex-wrap: wrap;
    text-align: left;
  }

  .cab-left {
    width: 70%;
    min-width: 250px;
    margin-bottom: 10px;
  }

  .cab-price {
    width: 30%;
    min-width: 150px;
    align-items: flex-start;
    text-align: left;
    margin-top: 10px;
  }

  .price-info {
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  .filter-options {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .filter-chip {
    padding: 6px 10px;
    font-size: 12px;
    margin: 2px;
  }
}

@media (max-width: 480px) {
  .filters-sidebar {
    padding: 10px;
  }

  .results-main {
    padding: 10px;
  }

  .results-header h2 {
    font-size: 16px;
  }

  .results-header p {
    font-size: 13px;
  }

  .cab-card {
    flex-direction: column;
    align-items: stretch;
    text-align: left;
    padding: 10px;
  }

  .cab-left {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .cab-image {
    width: 94px;
    height: 75px;
    margin-right: 10px;
  }

  .cab-img {
    width: 161px;
    height: 71%;
  }


  .cab-details {
    flex: 1;
  }

  .cab-details h3 {
    font-size: 14px;
    white-space: wrap;
    margin: 0 0 5px 0;
  }

  .cab-details p {
    font-size: 12px;
    margin: 3px 0;
  }

  .cab-price {
    width: 100%;
    align-items: flex-start;
    text-align: left;
    margin-top: 10px;
  }

  .price-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  /* Mobile: Display all price elements and button horizontally */
  .price-button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 5px;
  }

  .final-price {
    font-size: 20px;
  }

  .discount-badge,
  .original-price {
    font-size: 12px;
  }

  .price-button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 5px;
  }

  .instant-booking {
    width: auto;
    min-width: 100px;
    text-align: center;
    padding: 8px 16px;
    font-size: 14px;
  }

  .filter-chip {
    font-size: 11px;
    padding: 5px 8px;
    margin: 2px;
  }

  .compare-btn {
    padding: 8px;
    font-size: 13px;
  }

  .filter-section h4 {
    font-size: 14px;
  }

  .tax-info {
    font-size: 11px;
  }
}

/* Mobile: Display all elements horizontally */
@media (max-width: 768px) {
  .cab-price {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: stretch;
  }

  .price-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    margin-bottom: 5px;
  }

  .tax-and-button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
  }

  .price-button-container {
    flex-shrink: 0;
  }

  .tax-info {
    margin: 0;
    white-space: nowrap;
    font-size: 11px;
    flex: 1;
    min-width: 0;
  }

  .instant-booking {
    width: auto;
    min-width: 100px;
    text-align: center;
    padding: 8px 16px;
    font-size: 14px;
    flex-shrink: 0;
  }

  .no-cabs-found {
    height: 50vh;
  }

  .no-cabs-logo {
    width: 100px;
  }
}

@media (max-width: 360px) {
  .cab-left {
    flex-direction: column;
    align-items: flex-start;
  }

  .cab-image {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .final-price {
    font-size: 18px;
  }

  .instant-booking {
    padding: 7px 14px;
    font-size: 13px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 998;
}

.bottom-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  z-index: 1002;
}

.bottom-buttons button {
  flex: 1;
  margin: 0 5px;
  padding: 10px;
  border: none;
  background: #007bff;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

@media (min-width: 769px) {
  .bottom-buttons {
    display: none;
  }

  /* Ensure proper sticky behavior on larger screens */
  .filters-sidebar {
    position: sticky;
    top: 64px;
    height: calc(100vh - 64px);
    overflow-y: auto;
  }

  .results-main {
    max-height: calc(100vh - 64px);
    overflow-x: hidden;
  }
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
}

.sort-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-modal {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 80%;
  max-width: 320px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.sort-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.sort-chip {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px;
  margin: 8px 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f7f7f7;
  cursor: pointer;
  font-size: 14px;
}

.sort-chip.active {
  background: #e5f0ff;
  color: #007bff;
  border-color: #007bff;
}

.apply-btn {
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

/* No cabs found message */
.no-cabs-found {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
  width: 100%;
  text-align: center;
  padding: 20px;
}

.no-cabs-content {
  max-width: 400px;
}

.no-cabs-logo {
  opacity: 0.6;
  margin-bottom: 20px;
}

.no-cabs-found h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

.no-cabs-found p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.reset-filters-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.reset-filters-btn:hover {
  background: #0056b3;
}
</style>
